import { FunctionComponent, useState, useEffect } from "react";
import styles from "./LoadingProgress.module.scss";
import { LinearProgress } from "@rmwc/linear-progress";
import "@rmwc/linear-progress/styles";

let intervalJob: NodeJS.Timeout;

const LoadingProgress: FunctionComponent = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    intervalJob = setInterval(() => {
      setProgress((progress: number) =>
        progress + 0.09 >= 0.99 ? 0.99 : progress + 0.09
      );
    }, 50);
    return () => {
      clearInterval(intervalJob);
    };
  }, []);
  return (
    <div className={styles.progressBar}>
      <LinearProgress progress={progress} />
    </div>
  );
};

export { LoadingProgress, LoadingProgress as default };
